<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="isCreate ? newRules: updateRules"
          ref="ruleForm"
          class="flex flex-row w-full"
          autocomplete="off"
        >
          <div class="flex-1 hideHScroll">

              <base-collapsible-form 
                ref="baseCollapsibleConfigGeneral" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{"Datos del distribuidor"}}</h2>
                </template>
                <template slot="content">

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('distributors.name')}}
                  <el-form-item prop="name">
                    <el-input
                      :disabled="!isCreate"
                      clearable
                      class="w-full"
                      v-model="form.name"
                      maxlength='100'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            
            <div class="lg:mb-2">
              <AccessibleElSelect
                v-model="form.TipoDistribuidor"
                prop="TipoDistribuidor"
                :options="tiposDistribuidorForAccessibleSelect"
                :withFormItem="true"
                id-prefix="distributor"
                @change="onChangeTipoDistribuidor"
              >
                <template slot="label"><base-obligatory-icon/>{{$t('distributors.tipo_distribuidor')}}</template>
              </AccessibleElSelect>
            </div>

            <div class="lg:mb-2">
              <AccessibleElSelect
                v-model="form.TipoProvisionamiento"
                prop="TipoProvisionamiento"
                :options="tiposProvisionamientoForAccessibleSelect"
                :withFormItem="true"
                :isDisabled="!isCreate"
                id-prefix="distributor"
              >
                <template slot="label"><base-obligatory-icon v-if="isCreate"/>{{$t('distributors.tipo_provisionamiento')}}</template>
              </AccessibleElSelect>
            </div>

            <div class="lg:mb-2" v-if="form.TipoProvisionamiento === 1">         
              <label for="switch-permite-wizard" class="w-full text-sm font-semibold text-secondary-600 flex flex-col">
                {{$t('clients.permite_wizard')}}
                <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
              </label>
              <el-switch 
                id="switch-permite-wizard"
                :aria-label="$t('clients.permite_wizard')"
                class="switch-text break-normal both-switch mt-2 mb-4" 
                v-model="form.PermiteWizard" 
                :active-text="$t('companies.active')"/>
            </div>

            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            v-if="!isCreate || form.TipoProvisionamiento == 2"
            ref="baseCollapsibleLicenciamiento" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{"Datos de licenciamiento"}}</h2>
            </template>
            <template slot="content">

            <div class="lg:mb-0" v-if="form.TipoProvisionamiento == 2">
              <div class="flex -mx-2 flex-col lg:flex-row items-end">
                <div class="px-2 w-full lg:mb-0 mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('distributors.num_clients')}}
                    <el-form-item prop="NumClientsTotal">
                      <el-input
                        clearable
                        class="w-full"
                        v-model.number="form.NumClientsTotal"
                        maxlength='4'
                      />
                    </el-form-item>
                  </label>
                </div>
                <div class="px-2 w-full lg:mb-0 mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('distributors.num_neos')}}
                    <el-form-item prop="NumNEOsTotal">
                      <el-input
                        clearable
                        class="w-full"
                        v-model.number="form.NumNEOsTotal"
                        maxlength='7'
                      />
                    </el-form-item>
                  </label>
                </div>
                <div class="px-2 w-full lg:mb-0 mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('distributors.stored_space')}}
                    <el-form-item prop="StoredSpaceTotal">
                      <el-input
                        clearable
                        class="w-full"
                        v-model.number="form.StoredSpaceTotal"
                        maxlength='7'
                      >
                        <template slot="append">MB</template>
                      </el-input>
                    </el-form-item>
                  </label>
                </div>
                <div class="px-2 w-full lg:mb-0 mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('distributors.num_sms')}}
                    <el-form-item prop="NumSMSTotal">
                      <el-input
                        clearable
                        class="w-full"
                        v-model.number="form.NumSMSTotal"
                        maxlength='7'
                      />
                    </el-form-item>
                  </label>
                </div>
              </div>
            </div>
            
            <div class="lg:mb-0" v-if="form.TipoProvisionamiento == 2">
              <div class="flex -mx-2 flex-col lg:flex-row">
                <div class="px-2 w-full lg:mb-0 mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('clients.num_companies')}}
                    <el-form-item prop="NumCompaniesTotal">
                      <el-input
                        clearable
                        class="w-full"
                        v-model.number="form.NumCompaniesTotal"
                        maxlength='7'
                      />
                    </el-form-item>
                  </label>
                </div>
                <div class="px-2 w-full lg:mb-0">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('clients.num_pgncif')}}
                    <el-form-item prop="NumeroSedesxCIFEmpresasTotal">
                      <el-input
                        clearable
                        class="w-full"
                        v-model.number="form.NumeroSedesxCIFEmpresasTotal"
                        maxlength='7'
                      />
                    </el-form-item>
                  </label>
                </div>
                <div class="px-2 w-full lg:mb-0 mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('clients.num_users')}}
                    <el-form-item prop="NumUsersTotal">
                      <el-input
                        clearable
                        class="w-full"
                        v-model.number="form.NumUsersTotal"
                        maxlength='4'
                      />
                    </el-form-item>
                  </label>
                </div>
              </div>
            </div>

            <div v-if="!isCreate">
              <div class="mb-4">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('distributors.num_clients')}}</label>
                <div class="flex flex-row mt-2">
                  <span class="w-32 text-sm text-secondary-600 dark:text-darkblue-200">{{ form.NumClients }} / {{ form.NumClientsTotalProgres }}</span>
                  <el-progress :aria-label="$t('distributors.num_clients')" class="w-full dark:text-darkblue-200" :percentage="percentageNumClients" :color="customColorMethod"></el-progress>
                </div>                
              </div>
              <div class="mb-4">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('distributors.num_neos')}}</label>
                <div class="flex flex-row mt-2">
                  <span class="w-32 text-sm text-secondary-600 dark:text-darkblue-200">{{ form.NumNEOs }} / {{ form.NumNEOsTotalProgres }}</span>
                  <el-progress :aria-label="$t('distributors.num_neos')" class="w-full dark:text-darkblue-200" :percentage="percentageNumNEOs" :color="customColorMethod"></el-progress>
                </div>
              </div>
              <div class="mb-4">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('distributors.stored_space')}}</label>
                <div class="flex flex-row mt-2">
                  <span class="w-32 text-sm text-secondary-600 dark:text-darkblue-200">{{ form.StoredSpace }} / {{ form.StoredSpaceTotalProgres }}</span>
                  <el-progress :aria-label="$t('distributors.stored_space')" class="w-full dark:text-darkblue-200" :percentage="percentageStoredSpace" :color="customColorMethod"></el-progress>
                </div>
              </div>
              <div class="mb-4" v-if="form.NumSMSTotalProgres">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('distributors.num_sms')}}</label>
                <div class="flex flex-row mt-2">
                  <span class="w-32 text-sm text-secondary-600 dark:text-darkblue-200">{{ form.NumSMS }} / {{ form.NumSMSTotalProgres }}</span>
                  <el-progress :aria-label="$t('distributors.num_sms')" class="w-full dark:text-darkblue-200" :percentage="percentageNumSMS" :color="customColorMethod"></el-progress>
                </div>
              </div>
              <div class="mb-4">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.num_companies')}}</label>
                <div class="flex flex-row mt-2">
                  <span class="w-32 text-sm text-secondary-600 dark:text-darkblue-200">{{ form.NumCompanies }} / {{ form.NumCompaniesTotalProgres }}</span>
                  <el-progress :aria-label="$t('clients.num_companies')" class="w-full dark:text-darkblue-200" :percentage="percentageNumCompanies" :color="customColorMethod"></el-progress>
                </div>
              </div>
              <div class="mb-4">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.num_pgncif')}}</label>
                <div class="flex flex-row mt-2">
                  <span class="w-32 text-sm text-secondary-600 dark:text-darkblue-200">{{ form.NumeroSedesxCIFEmpresas }} / {{ form.NumeroSedesxCIFEmpresasTotalProgres }}</span>
                  <el-progress :aria-label="$t('clients.num_pgncif')" class="w-full dark:text-darkblue-200" :percentage="percentageNumeroSedesxCIFEmpresas" :color="customColorMethod"></el-progress>
                </div>
              </div>
              <div class="mb-4">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.num_users')}}</label>
                <div class="flex flex-row mt-2">
                  <span class="w-32 text-sm text-secondary-600 dark:text-darkblue-200">{{ form.NumUsers }} / {{ form.NumUsersTotalProgres }}</span>
                  <el-progress :aria-label="$t('clients.num_users')" class="w-full dark:text-darkblue-200" :percentage="percentageNumUsers" :color="customColorMethod"></el-progress>
                </div>
              </div>
            </div>

            </template>
          </base-collapsible-form>
          
            <div v-if="isCreate">
              <base-collapsible-form 
                ref="baseCollapsibleConfigUserInitial" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{"Datos de usuario distribuidor inicial"}}</h2>
                </template>
                <template slot="content">
                  <div v-if="isCreate" class="lg:mb-2">
                    <div class="mandatory">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('configurations.username')}}
                        <el-form-item prop="username">
                          <el-input
                            :disabled="!isCreate"
                            clearable
                            class="w-full"
                            v-model="form.username"
                            maxlength='50'
                          />
                        </el-form-item>
                      </label>
                    </div>
                  </div>
                  <div v-if="isCreate" class="lg:mb-2">
                    <div class="mandatory">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('configurations.email')}}
                        <el-form-item prop="email">
                          <el-input
                            :disabled="!isCreate"
                            clearable
                            class="w-full"
                            v-model="form.email"
                            maxlength='255'
                            autocomplete="email"
                          />
                        </el-form-item>
                      </label>
                    </div>
                  </div>
                  <div  v-if="isCreate" class="lg:mb-2">
                    <div class="mandatory">
                      <AccessibleElSelect
                        v-model="form.roleId"
                        prop="roleId"
                        :options="rolesForAccessibleSelect"
                        :withFormItem="true"
                        id-prefix="distributor"
                      >
                        <template slot="label"><base-obligatory-icon/>{{$t('configurations.rol')}}</template>
                      </AccessibleElSelect>
                    </div>
                  </div>
                  
                  <div v-if="isCreate" class="lg:mb-2">
                    <AccessibleElSelect
                      v-model="form.tipoAuth"
                      prop="tipoAuth"
                      :options="tiposAuthForAccessibleSelect"
                      :withFormItem="true"
                      :isDisabled="true"
                      id-prefix="distributor"
                    >
                      <template slot="label"><base-obligatory-icon v-if="isCreate"/>{{$t('configurations.tipo_auth')}}</template>
                    </AccessibleElSelect>
                  </div>
                  <div v-if="isCreate && this.form.tipoAuth !== 1 && this.form.tipoAuth !== 3" class="lg:mb-4">
                    <div class="lg:mb-2">
                      <base-password-form-item v-model="form.password" autocomplete="new-password"/>
                      <base-password-form-item v-model="form.repeat_password" :password="form.password" autocomplete="new-password" repeat />
                    </div>
                  </div>

                  <div v-if="isCreate" class="mb-6">
                    <div class="flex flex-col lg:flex-row lg:space-x-4">
                      <div class="flex flex-row items-center mb-4 lg:mb-0">
                        <label for="switch-activo" class="sr-only">
                          {{$t('app.active')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                        </label>
                        <el-switch 
                          id="switch-activo"
                          :aria-label="$t('app.active')"
                          class="switch-text break-normal" 
                          v-model="form.Activo" 
                          :active-text="$t('app.active')">
                        </el-switch>
                      </div>
                    </div>
                  </div>
                </template>
              </base-collapsible-form>
            </div>
          </div>

        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="isCreate ? $t('app.cancel') : $t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            v-if="!isCreate"
            mode="primary"
            :text="$t('app.goto_clients')"
            icon="company"
            @click="goToClients"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            v-if="!isCreate"
            mode="primary"
            :text="$t('app.goto_users')"
            icon="user"
            @click="goToUsers"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('app.save')"
            icon="save"
            @click="submitForm('ruleForm')"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
    </template>
  </detail-layout>
</template>

<script>
import { bus } from '@/main'
import { i18n } from '@/i18n'
import DetailLayout from '@/components/layout/DetailLayout.vue'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'
import { newDistributor } from '@/services/distributors/newDistributor'
import { getDistributor } from '@/services/distributors/getDistributor'
import { updateDistributor } from '@/services/distributors/updateDistributor'
import { email as emailRegex } from '@/utils/regex'
import { TIPOS_AUTH } from '@/config/tipos-auth'
import { TIPOS_DISTRIBUIDOR } from '@/config/tipos-distribuidor'
import { TIPOS_DISTRIBUIDOR_PROVISIONAMIENTO } from '@/config/tipos-distribuidor-provisionamiento'
import { ROLES } from '@/config/roles'

function isValidNumLicense (value) {
  if (Number.isInteger(parseFloat(value))) {
    if (value >= 0 && value <= 9999999) {
      return true
    }
  }
  return false
}

export default {
  /* eslint-disable camelcase */
  name: 'distributor-detail',
  components: {
    DetailLayout,
    AccessibleElSelect,
  },
  data: function () {
    return {
      showGeneratePassword: false,
      searchView: false,
      activeName: 'es',
      header: {
        title: 'DETALLE DE DISTRIBUIDOR',
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'configurationssa'
      },
      tiposAuth: TIPOS_AUTH,
      tiposDistribuidor: TIPOS_DISTRIBUIDOR,
      tiposProvisionamiento: TIPOS_DISTRIBUIDOR_PROVISIONAMIENTO,
      form: this.getDefaultForm(),
      updateRules: {
        name: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        TipoDistribuidor: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        TipoProvisionamiento: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        NumNEOsTotal: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumClientsTotal: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        StoredSpaceTotal: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { required: true, validator: this.isNumberConnectionsValid, trigger: 'blur' }
        ],
        NumSMSTotal: [
          { required: false, validator: this.isNumberConnectionsValid, trigger: 'blur' }
        ],
        NumCompaniesTotal: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumUsersTotal: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumeroSedesxCIFEmpresasTotal: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { required: true, validator: this.isNumberConnectionsValid, trigger: 'blur' }
        ],
      },
      newRules: {
        name: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        username: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        email: [
          { validator: this.isEmailValid, trigger: 'blur' }
        ],
        roleId: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        tipoAuth: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        NumClientsTotal: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumNEOsTotal: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        StoredSpaceTotal: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumSMSTotal: [
          { required: false, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumCompaniesTotal: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumUsersTotal: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumeroSedesxCIFEmpresasTotal: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { required: true, validator: this.isNumberConnectionsValid, trigger: 'blur' }
        ],
      }
    }
  },
  computed: {
    percentageNumClients: function () {
      if (this.form.NumClients === 0 || this.form.NumClientsTotalProgres === 0) return 0
      return Math.round((parseInt(this.form.NumClients) * 100) / parseInt(this.form.NumClientsTotalProgres)) 
    },
    percentageNumNEOs: function () {
      if (this.form.NumNEOs === 0 || this.form.NumNEOsTotalProgres === 0) return 0
      return Math.round((parseInt(this.form.NumNEOs) * 100) / parseInt(this.form.NumNEOsTotalProgres)) 
    },
    percentageStoredSpace: function () {
      if (this.form.StoredSpace === 0 || this.form.StoredSpaceTotalProgres === 0) return 0
      return Math.round((parseInt(this.form.StoredSpace) * 100) / parseInt(this.form.StoredSpaceTotalProgres)) 
    },
    percentageNumSMS: function () {
      if (this.form.NumSMS === 0 || this.form.NumSMSTotalProgres === 0) return 0
      return Math.round((parseInt(this.form.NumSMS) * 100) / parseInt(this.form.NumSMSTotalProgres)) 
    },
    percentageNumCompanies: function () {
      if (this.form.NumCompanies === 0 || this.form.NumCompaniesTotalProgres === 0) return 0
      return Math.round((parseInt(this.form.NumCompanies) * 100) / parseInt(this.form.NumCompaniesTotalProgres)) 
    },
    percentageNumeroSedesxCIFEmpresas: function () {
      if (this.form.NumeroSedesxCIFEmpresas === 0 || this.form.NumeroSedesxCIFEmpresasTotalProgres === 0) return 0
      return Math.round((parseInt(this.form.NumeroSedesxCIFEmpresas) * 100) / parseInt(this.form.NumeroSedesxCIFEmpresasTotalProgres)) 
    },
    percentageNumUsers: function () {
      if (this.form.NumUsers === 0 || this.form.NumUsersTotalProgres === 0) return 0
      return Math.round((parseInt(this.form.NumUsers) * 100) / parseInt(this.form.NumUsersTotalProgres)) 
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    id: function () {
      return this.$route.params.id
    },
    isCreate: function () {
      return this.id === -1 || this.id === '-1'
    },
    roles: function () {
      if (this.form.TipoDistribuidor === 1) return ROLES.filter(r => r.id === 5)
      return ROLES.filter(r => r.id === 5 || r.id === 6)
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    tiposDistribuidorForAccessibleSelect () {
      return this.tiposDistribuidor.map(tipo => ({
        id: tipo.id,
        name: tipo.name,
        value: tipo.id,
        disabled: tipo.disabled === true
      }))
    },
    tiposProvisionamientoForAccessibleSelect () {
      return this.tiposProvisionamiento.map(tipo => ({
        id: tipo.id,
        name: tipo.name,
        value: tipo.id,
        disabled: tipo.disabled === true
      }))
    },
    rolesForAccessibleSelect () {
      return this.roles.map(role => ({
        id: role.id,
        name: role.name,
        value: role.id,
        disabled: role.disabled === true
      }))
    },
    tiposAuthForAccessibleSelect () {
      return this.tiposAuth.map(tipo => ({
        id: tipo.id,
        name: tipo.name,
        value: tipo.id,
        disabled: tipo.disabled === true
      }))
    },
    calcTotalPGNCIF () {
      if (!this.form.NumLocations || !this.form.NumCompanies) return 0
      return parseInt(this.form.NumLocations) * parseInt(this.form.NumCompanies)
    },
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    'form.TipoProvisionamiento': function (value, oldValue) {
      if (value === 2) {
        setTimeout(() => {
          this.$refs.baseCollapsibleLicenciamiento.toggle()
        }, 100)
      }
    },
  },
  created: async function () {
    const breadcrumbs = []
    breadcrumbs.push({
      path: 'configurationssa',
      name: this.$i18n.t('app.configurations')
    })

    this.disableRoutes()
    if (!this.isCreate) {
      await this.downloadData(this.id)
      breadcrumbs.push({
        path: 'configurations/distributors',
        name: this.$i18n.t('distributors.header')
      })
      breadcrumbs.push({ path: '', name: this.form.name })
      this.$store.commit('app/setheaderBreadCrumb', this.form.name)
    } else {
      breadcrumbs.push({
        path: '',
        name: this.$i18n.t('distributors.new')
      })
    }
    this.header.breadcrumb = breadcrumbs
  },
  mounted () {
    this.$refs.baseCollapsibleConfigGeneral.toggle()
    if (this.isCreate) {
      this.$refs.baseCollapsibleConfigUserInitial.toggle()
    }
    this.resetControlFormChanges()
  },
  methods: {
    disableRoutes: function () {
      const objDisableRoutes = {
        disableModules: this.form.TipoProvisionamiento === 1,
        disableLocations: this.form.TipoProvisionamiento === 1,
      }
      bus.$emit('disableOptionsDistributor', objDisableRoutes)
    },
    customColorMethod: function (percentage) {
      if (this.form.TipoProvisionamiento === 1) {
        return 'var(--primary-400)'
      }
      if (percentage >= 80) {
        return '#FF382C'
      } else {
        if (this.darkMode) return 'var(--primary-400)'
        else return 'var(--primary-800)'
      }
    },
    onChangeTipoDistribuidor () {
      this.form.roleId = null
    },
    getDistribuidorFilter () {
      const filters = {}
      filters.distribuidor = { label: 'Distribuidor', value: this.form.name }
      return filters
    },
    goToClients () {      
      this.$store.commit('clients/setMasterFilters', this.getDistribuidorFilter())
      this.$router.push({ name: 'configurations/clients' })
    },
    goToUsers () {      
      this.$store.commit('users/setMasterFilters', this.getDistribuidorFilter())
      this.$router.push({ name: 'configurations/users' })
    },
    isNumberValid: function (rule, value, callback) {
      if ((!value || value === '')) {
        if (rule.field === 'NumSMSTotal') {
          callback()
        }
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
      } else if (!isValidNumLicense(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.template.num_license'), callback)
      } else {
        callback()
      }
    },
    isNumberConnectionsValid: function (rule, value, callback) {
      if (value === null || value === undefined || value === '') {
        // return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
        callback()
      } else if (!isValidNumLicense(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.num_max_7'), callback)
      // } else if (value > this.calcTotalPGNCIF) {
      //   this.doAriaLiveAndReturnCallback(i18n.t('validation.template.num_license'), callback)
      } else {
        callback()
      }
    },
    getDefaultForm: function () {
      return {
        name: '',
        TipoDistribuidor: 1,
        TipoProvisionamiento: 1,
        PermiteWizard: false,
        username: '',
        email: '',
        roleId: null,
        Activo: true,
        password: '',
        repeat_password: '',
        tipoAuth: 0,

        NumClients: 2,
        NumNEOs: 2000,
        StoredSpace: 1000,
        NumSMS: 200,
        NumCompanies: 20,
        NumeroSedesxCIFEmpresas: 100,
        NumUsers: 40,

        NumNEOsTotal: 2000,
        NumClientsTotal: 2,
        StoredSpaceTotal: 1000,
        NumSMSTotal: 200,
        NumCompaniesTotal: 20,
        NumeroSedesxCIFEmpresasTotal: 100,
        NumUsersTotal: 40,

        NumNEOsTotalProgres: 0,
        NumClientsTotalProgres: 0,
        StoredSpaceTotalProgres: 0,
        NumSMSTotalProgres: 0,
        NumCompaniesTotalProgres: 0,
        NumeroSedesxCIFEmpresasTotalProgres: 0,
        NumUsersTotalProgres: 0,
      }
    },
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
      }
      if (!emailRegex.test(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.email'), callback)
      } else {
        callback()
      }
    },
    submitForm: function (formName) {
      if (this.isCreate) {
        this.newDistributorHandler(formName)
      } else {
        this.updateDistributorHandler(formName)
      }
    },
    newDistributorHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const payload = {
            Nombre: this.form.name,
            primerUsuario: {
              Nombre: this.form.username,
              Email: this.form.email,
              idRol: this.form.roleId,
              Activo: this.form.Activo,
              Password: this.form.password,
              idTipoAutenticacion: this.form.tipoAuth,
            },
            NumeroCIFEmpresas: this.form.NumCompaniesTotal,
            NumeroUsuarios: this.form.NumUsersTotal,
            NumeroSedesxCIFEmpresas: this.form.NumeroSedesxCIFEmpresasTotal,
            NumeroClientes: this.form.NumClientsTotal,
            NumeroNotificacionesAnuales: this.form.NumNEOsTotal,
            EspacioTotal: this.form.StoredSpaceTotal,
            NumeroSMS: this.form.NumSMSTotal,
            idTipoDistribuidor: this.form.TipoDistribuidor,
            idTipoProvisionamiento: this.form.TipoProvisionamiento,
            PermiteWizard: this.form.PermiteWizard,
          }
          const response = await newDistributor(payload)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Datos guardados correctamente', 'success')
            this.resetForm()
            this.form = this.getDefaultForm()
            this.resetControlFormChanges()
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    updateDistributorHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const payload = {
            IdDistribuidor: this.$route.params.id,
            Nombre: this.form.name,
            NumeroCIFEmpresas: this.form.NumCompaniesTotal,
            NumeroUsuarios: this.form.NumUsersTotal,
            NumeroSedesxCIFEmpresas: this.form.NumeroSedesxCIFEmpresasTotal,
            NumeroClientes: this.form.NumClientsTotal,
            NumeroNotificacionesAnuales: this.form.NumNEOsTotal,
            EspacioTotal: this.form.StoredSpaceTotal,
            NumeroSMS: this.form.NumSMSTotal,
            idTipoDistribuidor: this.form.TipoDistribuidor,
            idTipoProvisionamiento: this.form.TipoProvisionamiento,
            PermiteWizard: this.form.PermiteWizard,
          }
          const response = await updateDistributor(payload)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Datos guardados correctamente', 'success')
            this.updateView()
            this.$store.commit('app/setheaderBreadCrumb', this.form.name)
            await this.downloadData(this.id)
            this.resetControlFormChanges()
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    goBack: function () {
      this.$router.push({ name: 'configurations/distributors' })
    },
    downloadData: async function (id) {
      let distributor = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idDistribuidor: id
        }
        distributor = await getDistributor(params)
        this.setDistributor(distributor.distribuidor)
        // Datos Almacenamiento
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return distributor
    },
    setDistributor: function (client) {
      this.form.name = client.Nombre

      this.form.NumCompanies = client.NumeroCIFEmpresas ? client.NumeroCIFEmpresas : 0
      this.form.NumUsers = client.NumeroUsuarios ? client.NumeroUsuarios : 0
      this.form.NumeroSedesxCIFEmpresas = client.NumeroSedesxCIFEmpresas ? client.NumeroSedesxCIFEmpresas : 0
      this.form.NumClients = client.NumeroClientes ? client.NumeroClientes : 0
      this.form.NumNEOs = client.NumeroNotificacionesAnuales ? client.NumeroNotificacionesAnuales : 0
      this.form.StoredSpace = client.Espacio ? client.Espacio : 0
      this.form.NumSMS = client.NumeroSMS ? client.NumeroSMS : 0

      this.form.NumCompaniesTotal = client.NumeroCIFEmpresasTotal ? client.NumeroCIFEmpresasTotal : 0
      this.form.NumUsersTotal = client.NumeroUsuariosTotal ? client.NumeroUsuariosTotal : 0
      this.form.NumeroSedesxCIFEmpresasTotal = client.NumeroSedesxCIFEmpresasTotal ? client.NumeroSedesxCIFEmpresasTotal : 0
      this.form.NumClientsTotal = client.NumeroClientesTotal ? client.NumeroClientesTotal : 0
      this.form.NumNEOsTotal = client.NumeroNotificacionesAnualesTotal ? client.NumeroNotificacionesAnualesTotal : 0
      this.form.StoredSpaceTotal = client.EspacioTotal ? client.EspacioTotal : 0
      this.form.NumSMSTotal = client.NumeroSMSTotal ? client.NumeroSMSTotal : 0

      this.form.NumCompaniesTotalProgres = client.NumeroCIFEmpresasTotal ? client.NumeroCIFEmpresasTotal : 0
      this.form.NumUsersTotalProgres = client.NumeroUsuariosTotal ? client.NumeroUsuariosTotal : 0
      this.form.NumeroSedesxCIFEmpresasTotalProgres = client.NumeroSedesxCIFEmpresasTotal ? client.NumeroSedesxCIFEmpresasTotal : 0
      this.form.NumClientsTotalProgres = client.NumeroClientesTotal ? client.NumeroClientesTotal : 0
      this.form.NumNEOsTotalProgres = client.NumeroNotificacionesAnualesTotal ? client.NumeroNotificacionesAnualesTotal : 0
      this.form.StoredSpaceTotalProgres = client.EspacioTotal ? client.EspacioTotal : 0
      this.form.NumSMSTotalProgres = client.NumeroSMSTotal ? client.NumeroSMSTotal : 0

      this.form.TipoDistribuidor = client.idTipoDistribuidor ? client.idTipoDistribuidor : null
      this.form.TipoProvisionamiento = client.idTipoProvisionamiento ? client.idTipoProvisionamiento : null
      this.form.PermiteWizard = client.PermiteWizard ? client.PermiteWizard : false

      this.disableRoutes()
      this.resetControlFormChanges()
    },
    updateView: function () {
      this.header.breadcrumb[2].name = this.form.name
    }
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
.hideHScroll {
  overflow-x: hidden;
}
</style>

